import { Injectable, signal } from '@angular/core';
import { Hex } from 'viem';

export type ProfileCardPlacement = 'below' | 'left';

export interface ProfileCardTarget {
  address: Hex;
  username: string | null;
  twitterHandle: string | null;
  anchor: HTMLElement;
  placement?: ProfileCardPlacement;
}

@Injectable({ providedIn: 'root' })
export class ProfileCardOverlayService {
  private readonly _state = signal<ProfileCardTarget | null>(null);
  readonly state = this._state.asReadonly();

  openFor(target: ProfileCardTarget): void {
    const current = this._state();
    if (current && current.anchor === target.anchor) {
      this._state.set(null);
      return;
    }
    this._state.set(target);
  }

  close(): void {
    this._state.set(null);
  }
}
